module.exports = __webpack_public_path__ + "media/images/sp/items/board/board_01-1fbfa4aa4460a58e2b85d2121071d11b.jpg";